exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{\r\n  border-width:0 !important;\n}\r\n", ""]);

// exports
